<template>
  <b-row
    v-if="$route.meta.breadcrumb && $route.meta.breadcrumb.length"
    class="content-header poda-content-header"
  >
    <b-col
      class="content-header-left mb-2"
      cols="12"
    >
      <b-breadcrumb class="breadcrumb-slash poda-breadcrumb mb-0">
        <b-breadcrumb-item
          v-for="item in $route.meta.breadcrumb"
          :key="item.text"
          :active="item.active"
          :to="item.to"
        >
          {{ item.text }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
  },
}
</script>
